import { ColumnDef } from '@tanstack/react-table';

import { NextTFunction } from '@/i18n/client';

import { Approval } from '../../../src/typings/ActivityDataDetailsTypings';
import { EmissionsType } from '../../../src/typings/CreateActivityDataTypings';

export const getShareholdingRatioHeader = (
  t: NextTFunction,
  isBulkPreview: boolean = false,
): ColumnDef<Approval & EmissionsType> => {
  const accessorKey = isBulkPreview ? 'metadata.shareHolding' : 'activityData.metadata.shareHolding';
  return {
    header: t('org-cfv-data-entry.shareholding'),
    accessorKey,
    cell: ({ getValue }) => `${getValue() as string}%`,
  };
};
